export default "__VITE_ASSET__f5bb8998__"